import { render, staticRenderFns } from "./Checkups.vue?vue&type=template&id=9f167de8&scoped=true&"
import script from "./Checkups.vue?vue&type=script&lang=js&"
export * from "./Checkups.vue?vue&type=script&lang=js&"
import style0 from "./Checkups.vue?vue&type=style&index=0&id=9f167de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f167de8",
  null
  
)

export default component.exports